import createPersistedState from 'vuex-persistedstate'
import { Plugin } from '@nuxt/types'

const plugin: Plugin = ({ store }) => {
    createPersistedState({
        key: 'mi',
        paths: [
            'currency',
            'cart',
            'wishlist',
            'compare',
            'auth',
            'user',
            'activeCartID',
        ]
    })(store)
}

export default plugin
